export default __webpack_public_path__ + "static/media/clinic.10b33ca0.png";